import callApi from 'res-api-cli/build/callApi';

/**
 * POST /cms/evidence-bundles/{id}/complete
 *
 * Signals true download completion to cms.
 * cms sets downloadedAt, deletes the S3 ZIP eagerly (zipDeletedAt), and
 * transitions the bundle status to CONSUMED. The DynamoDB row is retained.
 *
 * This endpoint is INITIATOR-ONLY — cms enforces that the caller equals
 * requestedByUserId, returning 403 otherwise.
 *
 * Called best-effort once the browser download has been kicked off (the bundle
 * is delivered via a presigned anchor download — see triggerAnchorDownload). If
 * this call never lands, the 24h S3 lifecycle is the backstop.
 *
 * @see CD-7668 plan — Task 3.2
 */
const completeEvidenceBundle = (bundleId: string): Promise<void> =>
  callApi({
    method: 'POST',
    url: `/cms/evidence-bundles/${encodeURIComponent(bundleId)}/complete`,
    data: {},
  });

export default completeEvidenceBundle;
